export default __webpack_public_path__ + "static/media/ntjBg.0c8fae45.png";